import React, { useState, useEffect, useRef } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useConfig } from '../context/ConfigContext';
import axios from 'axios';
import {
  LayoutDashboard, Package, TrendingUp, ShoppingCart,
  FileText, Users, Settings, LogOut, Menu, X, Store, UserCheck,
  DollarSign, Truck, Warehouse, ArrowRightLeft, Landmark, ClipboardList,
  ChevronDown, Bell, Plus, Megaphone, GitBranch, Sparkles, Send, BarChart3,
  Globe, Palette, FileSpreadsheet, CreditCard, Gift, Award
} from 'lucide-react';
import './LayoutFeveo.css';

// ── Menu groups ────────────────────────────────────────────────
const makeMenu = (role) => {
  const all = [
    {
      group: null,
      label: 'Dashboard',
      path: '/dashboard',
      icon: LayoutDashboard,
      roles: ['admin','admin-entreprise','admin-pro','admin-boutique','caissier','gestionnaire']
    },
    {
      group: 'Catalogue',
      icon: Package,
      roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire','caissier'],
      children: [
        { label: 'Boutiques',  path: '/boutiques',  icon: Store,       roles: ['admin','admin-entreprise','admin-pro'] },
        { label: 'Produits',   path: '/produits',   icon: Package,     roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire','caissier'] },
        { label: 'Stock',      path: '/stock',      icon: TrendingUp,  roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'] },
      ]
    },
    {
      group: 'Fournisseurs',
      icon: Truck,
      roles: ['admin','admin-entreprise','admin-pro'],
      children: [
        { label: 'Fournisseurs',  path: '/fournisseurs',           icon: Truck,           roles: ['admin','admin-entreprise','admin-pro'] },
        { label: 'Commandes',     path: '/commandes-fournisseurs', icon: FileText,        roles: ['admin','admin-entreprise','admin-pro'] },
        { label: 'Dettes fourn.', path: '/dettes-fournisseurs',   icon: DollarSign,      roles: ['admin','admin-entreprise','admin-pro'] },
        { label: 'Transferts',    path: '/transferts-stock',       icon: ArrowRightLeft,  roles: ['admin','admin-entreprise','admin-pro','admin-boutique'] },
        { label: 'Entrepôts',     path: '/entrepots',              icon: Warehouse,       roles: ['admin','admin-entreprise','admin-pro','admin-boutique'] },
        { label: 'Inventaire',    path: '/inventaire',             icon: ClipboardList,   roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'] },
      ]
    },
    {
      group: 'Ventes',
      icon: ShoppingCart,
      roles: ['admin','admin-entreprise','admin-pro','admin-boutique','caissier','gestionnaire'],
      children: [
        { label: 'Caisse',    path: '/caisse',   icon: Landmark,    roles: ['admin','admin-entreprise','admin-pro','admin-boutique','caissier','gestionnaire'] },
        { label: 'Ventes',    path: '/ventes',   icon: ShoppingCart,roles: ['admin','admin-entreprise','admin-pro','admin-boutique','caissier','gestionnaire'] },
        { label: 'Factures',  path: '/factures', icon: FileText,    roles: ['admin','admin-entreprise','admin-pro','admin-boutique','caissier','gestionnaire'] },
        { label: 'Clients',   path: '/clients',  icon: UserCheck,   roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'] },
        { label: 'Dettes',    path: '/dettes',   icon: DollarSign,  roles: ['admin','admin-entreprise','admin-pro','admin-boutique'] },
      ]
    },
    {
      group: 'Marketing',
      icon: Megaphone,
      roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'],
      children: [
        { label: 'Funnel CRM',  path: '/marketing/crm',        icon: GitBranch, roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'] },
        { label: 'Créa Studio', path: '/marketing/creative',   icon: Sparkles,  roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'] },
        { label: 'Publications',path: '/marketing/publishing',  icon: Send,      roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'] },
        { label: 'Attribution', path: '/marketing/attribution', icon: BarChart3, roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'] },
      ]
    },
    {
      group: 'E-commerce',
      icon: Globe,
      roles: ['admin','admin-entreprise','admin-pro','admin-boutique'],
      children: [
        { label: 'Vitrines & Liens', path: '/ecommerce/vitrines',     icon: Palette,          roles: ['admin','admin-entreprise','admin-pro','admin-boutique'] },
        { label: 'Commandes',        path: '/ecommerce/commandes',     icon: ShoppingCart,     roles: ['admin','admin-entreprise','admin-pro','admin-boutique'] },
        { label: 'Import stock',     path: '/ecommerce/import-stock',  icon: FileSpreadsheet,  roles: ['admin','admin-entreprise','admin-pro','admin-boutique'] },
      ]
    },
    {
      group: 'Fidélité',
      icon: Award,
      roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'],
      children: [
        { label: 'Cartes',      path: '/loyalty/cartes',      icon: CreditCard, roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'] },
        { label: 'Récompenses', path: '/loyalty/recompenses', icon: Gift,       roles: ['admin','admin-entreprise','admin-pro','admin-boutique','gestionnaire'] },
        { label: 'Paramètres',  path: '/loyalty/parametres',  icon: Settings,   roles: ['admin','admin-entreprise','admin-pro','admin-boutique'] },
      ]
    },
    {
      group: 'Admin',
      icon: Settings,
      roles: ['admin','admin-entreprise','admin-pro','admin-boutique'],
      children: [
        { label: 'Utilisateurs',  path: '/utilisateurs', icon: Users,    roles: ['admin','admin-entreprise','admin-pro','admin-boutique'] },
        { label: 'Configuration', path: '/configuration', icon: Settings, roles: ['admin','admin-entreprise'] },
      ]
    },
  ];

  return all
    .filter(item => item.roles.includes(role))
    .map(item => ({
      ...item,
      children: item.children?.filter(c => c.roles.includes(role))
    }))
    .filter(item => !item.children || item.children.length > 0);
};

// ── Dropdown component ─────────────────────────────────────────
function NavDropdown({ item, isAnyChildActive }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const Icon = item.icon;

  return (
    <div className="hn-dropdown-wrap" ref={ref}>
      <button
        className={`hn-nav-btn ${isAnyChildActive ? 'hn-nav-btn--active' : ''}`}
        onClick={() => setOpen(v => !v)}
      >
        <Icon size={15} />
        <span>{item.group}</span>
        <ChevronDown size={13} className={`hn-chevron ${open ? 'hn-chevron--open' : ''}`} />
      </button>

      {open && (
        <div className="hn-dropdown">
          <div className="hn-dropdown-inner">
            {item.children.map(child => {
              const CIcon = child.icon;
              const active = location.pathname === child.path;
              return (
                <Link
                  key={child.path}
                  to={child.path}
                  className={`hn-dropdown-item ${active ? 'hn-dropdown-item--active' : ''}`}
                  onClick={() => setOpen(false)}
                >
                  <div className={`hn-dropdown-icon ${active ? 'hn-dropdown-icon--active' : ''}`}>
                    <CIcon size={16} />
                  </div>
                  <span>{child.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

// ── User menu ──────────────────────────────────────────────────
function UserMenu({ user, planInfo, logout }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const initials = `${user?.prenom?.charAt(0) || ''}${user?.nom?.charAt(0) || ''}`.toUpperCase() || 'U';

  return (
    <div className="hn-user-wrap" ref={ref}>
      <button className="hn-user-btn" onClick={() => setOpen(v => !v)}>
        <div className="hn-avatar">{initials}</div>
        <div className="hn-user-text">
          <span className="hn-user-name">{user?.prenom} {user?.nom}</span>
          <span className="hn-user-role">{user?.role}</span>
        </div>
        <ChevronDown size={13} className={`hn-chevron ${open ? 'hn-chevron--open' : ''}`} />
      </button>

      {open && (
        <div className="hn-user-dropdown">
          <div className="hn-user-dropdown-header">
            <div className="hn-avatar hn-avatar--lg">{initials}</div>
            <div>
              <div className="hn-user-dd-name">{user?.prenom} {user?.nom}</div>
              <div className="hn-user-dd-email">{user?.email}</div>
            </div>
          </div>
          {planInfo?.label && (
            <div className="hn-user-plan">
              <span>Plan</span>
              <span className={`hn-plan-badge hn-plan-${planInfo.code || 'base'}`}>{planInfo.label}</span>
              {planInfo.joursRestants < 30 && planInfo.joursRestants < 999 && (
                <span className="hn-plan-expiry">{planInfo.joursRestants}j restants</span>
              )}
            </div>
          )}
          <div className="hn-user-dd-divider" />
          <button className="hn-logout-btn" onClick={() => { setOpen(false); logout(); }}>
            <LogOut size={15} />
            Déconnexion
          </button>
        </div>
      )}
    </div>
  );
}

// ── Nav caissier simplifié ──────────────────────────────────────
const CAISSIER_NAV = [
  { label: 'Accueil',        path: '/dashboard',       icon: LayoutDashboard, color: '#a78bfa', bg: 'rgba(139,92,246,.18)', border: 'rgba(139,92,246,.4)'  },
  { label: 'Nouvelle vente', path: '/ventes/nouvelle', icon: Plus,            color: '#fff',    bg: '#16a34a',              border: '#16a34a', primary: true },
  { label: 'Articles',       path: '/produits',        icon: Package,         color: '#818cf8', bg: 'rgba(99,102,241,.18)', border: 'rgba(99,102,241,.4)'  },
  { label: 'Factures',       path: '/factures',        icon: FileText,        color: '#38bdf8', bg: 'rgba(14,165,233,.18)', border: 'rgba(14,165,233,.4)'  },
  { label: 'Clients',        path: '/clients',         icon: UserCheck,       color: '#34d399', bg: 'rgba(16,185,129,.18)', border: 'rgba(16,185,129,.4)'  },
  { label: 'Dettes',         path: '/dettes',          icon: DollarSign,      color: '#fbbf24', bg: 'rgba(245,158,11,.18)', border: 'rgba(245,158,11,.4)'  },
];

function CaissierNav({ location }) {
  return (
    <nav className="hn-caissier-nav">
      {CAISSIER_NAV.map((item) => {
        const Icon = item.icon;
        const active = location.pathname === item.path ||
          (item.path !== '/dashboard' && location.pathname.startsWith(item.path));
        return (
          <Link key={item.path} to={item.path}
            className={`hn-caissier-btn${active ? ' hn-caissier-btn--active' : ''}${item.primary ? ' hn-caissier-btn--primary' : ''}`}
            style={{
              '--c-color':  item.color,
              '--c-bg':     item.bg,
              '--c-border': item.border,
            }}>
            <span className="hn-caissier-ico"><Icon size={14}/></span>
            <span>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}

// ── Mobile menu ────────────────────────────────────────────────
function MobileMenu({ menuItems, location, onClose }) {
  return (
    <div className="hn-mobile-menu">
      <div className="hn-mobile-menu-inner">
        {menuItems.map((item, i) => {
          if (!item.children) {
            const Icon = item.icon;
            const active = location.pathname === item.path;
            return (
              <Link key={i} to={item.path} className={`hn-mob-item ${active ? 'hn-mob-item--active' : ''}`} onClick={onClose}>
                <Icon size={18} />
                <span>{item.label}</span>
              </Link>
            );
          }
          return (
            <div key={i} className="hn-mob-group">
              <div className="hn-mob-group-label">{item.group}</div>
              {item.children.map(child => {
                const CIcon = child.icon;
                const active = location.pathname === child.path;
                return (
                  <Link key={child.path} to={child.path} className={`hn-mob-item hn-mob-item--child ${active ? 'hn-mob-item--active' : ''}`} onClick={onClose}>
                    <CIcon size={16} />
                    <span>{child.label}</span>
                  </Link>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Main Layout ────────────────────────────────────────────────
export default function LayoutFeveo() {
  const { user, logout } = useAuth();
  const { marketingEnabled, ecommerceEnabled, loyaltyEnabled } = useConfig();
  const location = useLocation();
  const navigate = useNavigate();
  const [planInfo, setPlanInfo] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    axios.get('/api/abonnements').then(({ data }) => {
      if (data.superAdmin) { setPlanInfo({ code: 'super-admin', label: 'SUPER ADMIN', estValide: true, joursRestants: 999 }); return; }
      const code = data.plan || data?.planDetails?.code;
      setPlanInfo({ code, label: data.planDetails?.nom || (code ? code.toUpperCase() : ''), estValide: data.estValide, joursRestants: data.joursRestants });
    }).catch(() => {});
  }, []);

  const menuItems = makeMenu(user?.role || '')
    .filter(item => item.group !== 'Marketing' || marketingEnabled)
    .filter(item => item.group !== 'E-commerce' || ecommerceEnabled)
    .filter(item => item.group !== 'Fidélité' || loyaltyEnabled);

  const isChildActive = (item) =>
    item.children?.some(c => location.pathname.startsWith(c.path)) || false;

  return (
    <div className="hn-layout">

      {/* ── Topbar ── */}
      <header className="hn-topbar">
        <div className="hn-topbar-inner">

          {/* Left: Logo */}
          <Link to="/dashboard" className="hn-brand">
            <div className="hn-brand-icon">
              <ShoppingCart size={18} />
            </div>
            <span className="hn-brand-name">GestStock</span>
          </Link>

          {/* Center: Nav (desktop) */}
          {user?.role === 'caissier'
            ? <CaissierNav location={location}/>
            : (
              <nav className="hn-nav">
                {menuItems.map((item, i) => {
                  if (!item.children) {
                    const Icon = item.icon;
                    const active = location.pathname === item.path;
                    return (
                      <Link key={i} to={item.path} className={`hn-nav-btn ${active ? 'hn-nav-btn--active' : ''}`}>
                        <Icon size={15} />
                        <span>{item.label}</span>
                      </Link>
                    );
                  }
                  return <NavDropdown key={i} item={item} isAnyChildActive={isChildActive(item)} />;
                })}
              </nav>
            )
          }

          {/* Right: actions */}
          <div className="hn-topbar-right">
            <button className="hn-icon-btn" onClick={() => navigate('/ventes/nouvelle')} title="Nouvelle vente">
              <Plus size={17} />
            </button>
            <button className="hn-icon-btn" onClick={() => navigate('/stock')} title="Alertes stock">
              <Bell size={17} />
            </button>
            <UserMenu user={user} planInfo={planInfo} logout={logout} />

            {/* Mobile burger */}
            <button className="hn-burger" onClick={() => setMobileOpen(v => !v)}>
              {mobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <MobileMenu menuItems={menuItems} location={location} onClose={() => setMobileOpen(false)} />
        )}
      </header>

      {/* ── Page content ── */}
      <main className="hn-content">
        <Outlet />
      </main>
    </div>
  );
}
